import { render } from "./SoDoCho.vue?vue&type=template&id=8c054c62&scoped=true"
import script from "./SoDoCho.vue?vue&type=script&lang=js"
export * from "./SoDoCho.vue?vue&type=script&lang=js"

import "./SoDoCho.vue?vue&type=style&index=0&id=8c054c62&lang=css"
import "./SoDoCho.vue?vue&type=style&index=1&id=8c054c62&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c054c62"]])

export default __exports__